import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./FilterMenu.module.css";
import classNames from "classnames";
import CheckBoxItem from "../CheckBoxItem";
import DeleteBlackIcon from "../../icons/delete_black.svg";
import { ChevronDown } from "react-ikonate";
import Button from "shared/Button";

/**
 * Interactive component.
 * Modal used throughout the app for filtering.
 */
export function FilterMenu({ onClick, groups, onCollapse, isOpen }) {

  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {}, [selectedItems]);

  const changeSelectedItems = (clickedItem) => {
    var a = [...selectedItems];
    if (selectedItems.includes(clickedItem)) {
      let itemIndex = selectedItems.indexOf(clickedItem);
      a.splice(itemIndex, 1);
      setSelectedItems(a);
    } else {
      a.push(clickedItem);
      setSelectedItems(a);
    }
  };


  function filterOnClick(filters){
    onClick(filters);
    setSelectedItems([]);
  }

  return (
    <div
      className={classNames(styles.padding, {
        [styles.hidden]: !isOpen,
      })}
    >
      <div className={styles.modalContainer}>
        <button onClick={onCollapse} className={styles.exitButton}>
          <img
            className={styles.exitIcon}
            src={DeleteBlackIcon}
            alt="Exit Icon"
          />
        </button>
        <div className={styles.menuContainer}>
          <p className={styles.title}>FILTERS</p>
          <div className={styles.hr} />
          {groups.map((group, index) => (
            <div className={styles.filterGroup} key={index}>
              <input
                type="checkbox"
                id={group.groupName}
                defaultChecked={true}
                className={styles.groupFilterInput}
              />
              <label className={styles.groupTitle} htmlFor={group.groupName}>
                <ChevronDown className={styles.icon} /> <p>{group.groupName}</p>
              </label>
              <div className={styles.filterOptions}>
                {group.groupItems.map((item, index) => (
                  <div className={styles.filterItem} key={index}>
                    <CheckBoxItem
                      name={item}
                      checked={selectedItems.includes(item)}
                      onClick={() => {
                        changeSelectedItems(item);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
          <Button
            className={styles.filterButton}
            onClick={() => {
              filterOnClick(selectedItems);
            }}
          >
            FILTER
          </Button>
        </div>
      </div>
    </div>
  );
}

FilterMenu.propTypes = {
  /**
   * Function called when the filter btn is clicked
   */
  onClick: PropTypes.func,
  /**
   * Array of objects (groupName-String, groupItems-Array of Strings)
   */
  groups: PropTypes.arrayOf(PropTypes.shape({})),
  /**
   * Callback function for when the menu is closed
   */
  onCollapse: PropTypes.func,
  /**
   * Getter to determine if modal is displayed
   */
  isOpen: PropTypes.bool,
};
